import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type AvatarsContentFragment = { __typename?: 'NotificationGroupContent', avatars: Array<{ __typename?: 'NotificationAvatar', color?: Types.AvatarColor | null, userName: string, url?: string | null }> };

export type Avatars_NotificationGroupAccessRequestApproved_Fragment = { __typename?: 'NotificationGroupAccessRequestApproved', content: { __typename?: 'NotificationGroupContent', avatars: Array<{ __typename?: 'NotificationAvatar', color?: Types.AvatarColor | null, userName: string, url?: string | null }> } };

export type Avatars_NotificationGroupAccessRequestDenied_Fragment = { __typename?: 'NotificationGroupAccessRequestDenied', content: { __typename?: 'NotificationGroupContent', avatars: Array<{ __typename?: 'NotificationAvatar', color?: Types.AvatarColor | null, userName: string, url?: string | null }> } };

export type Avatars_NotificationGroupAccessRequestSubmitted_Fragment = { __typename?: 'NotificationGroupAccessRequestSubmitted' };

export type Avatars_NotificationGroupAssetAssignedToYou_Fragment = { __typename?: 'NotificationGroupAssetAssignedToYou', content: { __typename?: 'NotificationGroupContent', avatars: Array<{ __typename?: 'NotificationAvatar', color?: Types.AvatarColor | null, userName: string, url?: string | null }> } };

export type Avatars_NotificationGroupAssetStatusChanged_Fragment = { __typename?: 'NotificationGroupAssetStatusChanged', content: { __typename?: 'NotificationGroupContent', avatars: Array<{ __typename?: 'NotificationAvatar', color?: Types.AvatarColor | null, userName: string, url?: string | null }> } };

export type Avatars_NotificationGroupCommentCreated_Fragment = { __typename?: 'NotificationGroupCommentCreated', content: { __typename?: 'NotificationGroupContent', avatars: Array<{ __typename?: 'NotificationAvatar', color?: Types.AvatarColor | null, userName: string, url?: string | null }> } };

export type Avatars_NotificationGroupCommentCreatedShareAccess_Fragment = { __typename?: 'NotificationGroupCommentCreatedShareAccess', content: { __typename?: 'NotificationGroupContent', avatars: Array<{ __typename?: 'NotificationAvatar', color?: Types.AvatarColor | null, userName: string, url?: string | null }> } };

export type Avatars_NotificationGroupFileUploaded_Fragment = { __typename?: 'NotificationGroupFileUploaded', content: { __typename?: 'NotificationGroupContent', avatars: Array<{ __typename?: 'NotificationAvatar', color?: Types.AvatarColor | null, userName: string, url?: string | null }> } };

export type Avatars_NotificationGroupReplyCreated_Fragment = { __typename?: 'NotificationGroupReplyCreated', content: { __typename?: 'NotificationGroupContent', avatars: Array<{ __typename?: 'NotificationAvatar', color?: Types.AvatarColor | null, userName: string, url?: string | null }> } };

export type Avatars_NotificationGroupReplyCreatedShareAccess_Fragment = { __typename?: 'NotificationGroupReplyCreatedShareAccess', content: { __typename?: 'NotificationGroupContent', avatars: Array<{ __typename?: 'NotificationAvatar', color?: Types.AvatarColor | null, userName: string, url?: string | null }> } };

export type Avatars_NotificationGroupRequesterAccessRequestApproved_Fragment = { __typename?: 'NotificationGroupRequesterAccessRequestApproved' };

export type Avatars_NotificationGroupRequesterAccessRequestDenied_Fragment = { __typename?: 'NotificationGroupRequesterAccessRequestDenied' };

export type Avatars_NotificationGroupTranscriptCompletedSelf_Fragment = { __typename?: 'NotificationGroupTranscriptCompletedSelf', content: { __typename?: 'NotificationGroupContent', avatars: Array<{ __typename?: 'NotificationAvatar', color?: Types.AvatarColor | null, userName: string, url?: string | null }> } };

export type Avatars_NotificationGroupTransferBatchCompleted_Fragment = { __typename?: 'NotificationGroupTransferBatchCompleted', content: { __typename?: 'NotificationGroupContent', avatars: Array<{ __typename?: 'NotificationAvatar', color?: Types.AvatarColor | null, userName: string, url?: string | null }> } };

export type Avatars_NotificationGroupTransferBatchCompletedSelf_Fragment = { __typename?: 'NotificationGroupTransferBatchCompletedSelf', content: { __typename?: 'NotificationGroupContent', avatars: Array<{ __typename?: 'NotificationAvatar', color?: Types.AvatarColor | null, userName: string, url?: string | null }> } };

export type Avatars_NotificationGroupUserMentioned_Fragment = { __typename?: 'NotificationGroupUserMentioned', content: { __typename?: 'NotificationGroupContent', avatars: Array<{ __typename?: 'NotificationAvatar', color?: Types.AvatarColor | null, userName: string, url?: string | null }> } };

export type Avatars_NotificationGroupUserMentionedShareAccess_Fragment = { __typename?: 'NotificationGroupUserMentionedShareAccess', content: { __typename?: 'NotificationGroupContent', avatars: Array<{ __typename?: 'NotificationAvatar', color?: Types.AvatarColor | null, userName: string, url?: string | null }> } };

export type AvatarsFragment = Avatars_NotificationGroupAccessRequestApproved_Fragment | Avatars_NotificationGroupAccessRequestDenied_Fragment | Avatars_NotificationGroupAccessRequestSubmitted_Fragment | Avatars_NotificationGroupAssetAssignedToYou_Fragment | Avatars_NotificationGroupAssetStatusChanged_Fragment | Avatars_NotificationGroupCommentCreated_Fragment | Avatars_NotificationGroupCommentCreatedShareAccess_Fragment | Avatars_NotificationGroupFileUploaded_Fragment | Avatars_NotificationGroupReplyCreated_Fragment | Avatars_NotificationGroupReplyCreatedShareAccess_Fragment | Avatars_NotificationGroupRequesterAccessRequestApproved_Fragment | Avatars_NotificationGroupRequesterAccessRequestDenied_Fragment | Avatars_NotificationGroupTranscriptCompletedSelf_Fragment | Avatars_NotificationGroupTransferBatchCompleted_Fragment | Avatars_NotificationGroupTransferBatchCompletedSelf_Fragment | Avatars_NotificationGroupUserMentioned_Fragment | Avatars_NotificationGroupUserMentionedShareAccess_Fragment;

export const AvatarsContent = /*#__PURE__*/ gql`
    fragment AvatarsContent on NotificationGroupContent {
  avatars {
    color
    userName
    url
  }
}
    ` as unknown as DocumentNode<AvatarsContentFragment, unknown>;
export const Avatars = /*#__PURE__*/ gql`
    fragment Avatars on NotificationGroup {
  ... on NotificationGroupAssetAssignedToYou {
    content {
      ...AvatarsContent
    }
  }
  ... on NotificationGroupAssetStatusChanged {
    content {
      ...AvatarsContent
    }
  }
  ... on NotificationGroupCommentCreated {
    content {
      ...AvatarsContent
    }
  }
  ... on NotificationGroupCommentCreatedShareAccess {
    content {
      ...AvatarsContent
    }
  }
  ... on NotificationGroupFileUploaded {
    content {
      ...AvatarsContent
    }
  }
  ... on NotificationGroupReplyCreated {
    content {
      ...AvatarsContent
    }
  }
  ... on NotificationGroupReplyCreatedShareAccess {
    content {
      ...AvatarsContent
    }
  }
  ... on NotificationGroupTransferBatchCompleted {
    content {
      ...AvatarsContent
    }
  }
  ... on NotificationGroupTransferBatchCompletedSelf {
    content {
      ...AvatarsContent
    }
  }
  ... on NotificationGroupUserMentioned {
    content {
      ...AvatarsContent
    }
  }
  ... on NotificationGroupUserMentionedShareAccess {
    content {
      ...AvatarsContent
    }
  }
  ... on NotificationGroupTranscriptCompletedSelf {
    content {
      ...AvatarsContent
    }
  }
  ... on NotificationGroupAccessRequestDenied {
    content {
      ...AvatarsContent
    }
  }
  ... on NotificationGroupAccessRequestApproved {
    content {
      ...AvatarsContent
    }
  }
}
    ${AvatarsContent}` as unknown as DocumentNode<AvatarsFragment, unknown>;

        

        
export const useAvatarsContentFragment = (
  input: string | Omit<UseFragmentOptions<AvatarsContentFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'NotificationGroupContent' } };
    return input;
  })();

  return useFragment<AvatarsContentFragment>({
    fragment: AvatarsContent,
    fragmentName: 'AvatarsContent',
    ...options,
  });
};
  
        
        

        
export const useAvatarsFragment = (
  input: string | Omit<UseFragmentOptions<AvatarsFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'NotificationGroup' } };
    return input;
  })();

  return useFragment<AvatarsFragment>({
    fragment: Avatars,
    fragmentName: 'Avatars',
    ...options,
  });
};
  
        